<template>
  <span :class="['copy-button', { copied }]" @click="copy">
    <span class="copy-hover">
      <translate v-if="copied">Copied</translate>
      <translate v-else>Copy to clipboard</translate>
    </span>
    <img
      class="icon copy"
      src="@/assets/images/copy.svg"
      width="17"
      height="16"
      alt=""
    />
  </span>
</template>

<script setup lang="ts">
const props = defineProps<{
  textToCopy: string
}>()

const copied = ref(false)
let copiedTimeoutId: ReturnType<typeof setTimeout> | null = null

async function copy() {
  await navigator.clipboard.writeText(props.textToCopy)
  copied.value = true

  if (copiedTimeoutId) {
    clearTimeout(copiedTimeoutId)
  }
  copiedTimeoutId = setTimeout(() => {
    copied.value = false
  }, 3000)
}

onUnmounted(() => {
  if (copiedTimeoutId) {
    clearTimeout(copiedTimeoutId)
    copiedTimeoutId = null
  }
})
</script>

<style scoped>
.copy-button {
  position: relative;
  display: inline;
  white-space: nowrap;
  cursor: pointer;
}

.copy-hover {
  background: #555;
  border-radius: var(--border-radius);
  bottom: 100%;
  box-shadow: 0 0.1em 0.5em rgba(0, 0, 0, 0.4);
  color: white;
  display: none;
  left: 50%;
  padding: 0.3em 0.5em;
  position: absolute;
  transform: translate(-50%, 0);
}

.copy-hover::after {
  border-color: #555 transparent transparent transparent;
  border-style: solid;
  border-width: 5px;
  content: '';
  left: 50%;
  margin-left: -5px;
  position: absolute;
  top: 100%;
}

.copied .copy-hover {
  display: block;
}

@media (hover: hover) {
  .copy-button:hover .copy-hover {
    display: block;
  }
}
</style>
